module.exports = __webpack_public_path__ + "static/media/screen6.948684fb.png";